import { SelectedData } from "./../multi-house-calendar/multi-house-calendar.service";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { fromEvent, Subject } from "rxjs";
import { debounceTime, takeUntil, tap } from "rxjs";
import { DateModel, CalendarBuilder } from "@root/component/multi-calendar/multi-calendar.service";

import _ from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { NzMessageService } from "ng-zorro-antd/message";
import { IndexService } from "@root/router/index/index.service";
import { PlatformType } from "@root/config";
import { Translate } from "@root/util/decorator";
import { InternationalService } from "@root/international.service";
import { DateService } from "@root/shared/service/date.service";
import { Router } from "@angular/router";
import { ModalService } from "@root/router/index/modal.service";
import { AppService } from "@root/app.service";
import { CacheService } from "@delon/cache";
import { addThousandsSeparator } from "@root/util/number";
import {
  PriceChild,
  Parent,
  DateRange,
  EntityData,
  Bar,
  MultiHouseCalendarService,
  Child,
} from "../multi-house-calendar/multi-house-calendar.service";

enum HouseType {
  House = 0,
  Type = 1,
}

interface ICalendarMap {
  [houseId: string]: {
    [date: string]: any;
  };
}

interface IReservationMap {
  [houseId: string]: {
    [code: string]: any;
  };

  deleteSpecifiedReservation?: Function;
}

interface ITaskMap {
  [houseId: string]: {
    [taskId: string]: any;
  };

  hasTaskOnSpecifiedHouseAndDate?: Function;
  deleteSpecifiedTask?: Function;
}

interface DataOfSelectedDates {
  status: "open" | "close" | "diff" | "past";
  type?: HouseType;
  list?: {
    0?: Array<any>;
    1?: Array<any>;
  };
}

@Component({
  selector: "host-multi-house-price-calendar",
  templateUrl: "./multi-house-price-calendar.component.html",
  styleUrls: ["./multi-house-price-calendar.component.scss"],
})
export class MultiHousePriceCalendarComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly Platform: typeof PlatformType = PlatformType;
  _cursor = 0;
  // _listOfHouses: Partial<Record<0 | 1, Parent[]>> = {};
  _listOfHouses: (PriceChild & Parent)[] = [];
  @ViewChild("gridContainer")
  calendarContainer: ElementRef;
  @ViewChild("houseBody") houseBody: ElementRef;
  @ViewChild("calendarBody") calendarBody: ElementRef;
  // @ViewChild('pagination') pagination: TemplateRef<any>;
  @Input() readonly cellWidth = 56;
  @Input() readonly cellHeight = 46;
  // @Input() reservationStyle: 'status' | 'channel' = 'status';
  @Input() displayStock = true;
  @Input() displayThousandsSep = false;

  // @Input() listOfHouses = [];
  @Input()
  get listOfHouses() {
    return this._listOfHouses;
  }

  set listOfHouses(value) {
    this._listOfHouses = value;
    if (value?.length) {
      /** 日历接口的请求逻辑不再手动触发，而是依赖于房间数量的变化 */
      setTimeout(() => {
        const keys = this.collectUniqueKeysInViewport(this.calendarContainer.nativeElement);
        this.onScrollOfKeys.emit(keys);
      }, 300);
    }
  }

  houseIdsInViewport = new Set();

  @Input() calendarMap: ICalendarMap = {};
  @Input() reservationMap: IReservationMap = {};
  @Input() freeHouseCountMap = {};
  @Input() housesPriceMap = {};
  @Input() housesOversellMap = {};
  // @Input() currentThirdparty: number;
  // @Output() onClickPrice = new EventEmitter();
  // @Output() onClickReservation = new EventEmitter<string>();
  @Output() onClickChangeAvailable = new EventEmitter();
  @Output() onClickChangeTab = new EventEmitter<number>();
  @Output() onCalendarScrollToBottom = new EventEmitter<boolean>();
  @Output() onScrollOfKeys = new EventEmitter<string[]>();
  datesInViewCount = 20;
  listOfAllDates: Array<DateModel> = [];
  listOfDatesInView: Array<DateModel> = [];
  /** 选中状态所需要的数据 */
  selectedCellDates: DateRange = {
    head: null,
    last: null,
  };

  listOfSelectedData: EntityData<"house", "price"> = {
    type: null,
    payload: null,
  };

  /** 快捷气泡需要的数据 */
  dataOfShortcutPop: DataOfSelectedDates = {
    status: "open",
    list: {},
  };

  displayShortcutPop = false;
  hostStyle = {};
  bodyStyle = {};
  selectStatus: "none" | "doing" | "done" = "none";
  selectedRectStyle = null;
  private resize$ = this.indexService.resizeRaw$.pipe(
    debounceTime(500),
    tap(() => {
      this.recalculateDatesInViewCount();
      if (this.calendarBody) {
        this.checkIfScrollToBottom(this.calendarBody.nativeElement);
      }
    }),
  );

  private select$ = this.houseCalendarService.selectRaw$.pipe(
    tap((value: SelectedData<"house", "price">) => {
      console.log("select$: ", value);

      const { head, last } = value.dates;

      const status = value.status;
      // const headIndex = this.calendarService.offsetStart(head);
      // const lastIndex = this.calendarService.offsetStart(last);

      this.selectStatus = status;
      this.selectedCellDates = {
        // headIndex,
        // lastIndex,
        head,
        last,
        // id,
        // relatedHouse,
      };

      this.listOfSelectedData = value.data;

      this.displayShortcutPop = true;

      this.setSelectedRectStyle();
    }),
  );

  // private selectReservation$ = this.houseCalendarService.selectReservationRaw$.pipe(
  //   tap(value => {
  //     this.selectedReservation = value;
  //   })
  // );

  private scroll$ = this.houseCalendarService.scrollRaw$.pipe(
    tap((value) => {
      // let left;
      if (_.isNumber(value)) {
        this.scroll(value as number);
      } else if (value === "L") {
        this.scrollByDistance(this.calendarContainer.nativeElement.offsetWidth - 300 - this.cellWidth);
      } else if (value === "R") {
        this.scrollByDistance(-(this.calendarContainer.nativeElement.offsetWidth - 300 - this.cellWidth));
      } else {
        // 字符串或者moment型的日期
        this.scroll(this.calendarService.offsetStart(value as string));
      }
    }),
  );

  private dateFormatChange$ = this.dateService.dateFormatChange$.pipe(
    tap(() => {
      /** TODO: 逻辑整理 */
      this.listOfAllDates = this.calendarService.buildDefaultCalendar();
    }),
  );

  private destroy$ = new Subject();

  get cursor() {
    return this._cursor;
  }

  set cursor(value) {
    if (value !== this._cursor) {
      this._cursor = value;
      this.listOfDatesInView = this.listOfAllDates.slice(this.cursor, this.cursor + this.datesInViewCount);
    }
  }

  // get listOfDatesInView(): Array<DateModel> {
  //   return this.listOfAllDates.slice(this.cursor, this.cursor + this.datesInViewCount);
  // }

  // get calendarBodyHeight () {
  //   if (_.isEmpty(this.listOfHouses)) {
  //     return 0;
  //   }
  //   const header = 80;
  //   const calendarBody = this.calendarBody.nativeElement.clientHeight;
  //   const paddingBottom = 60;
  //   const paddingTop = 10;
  //
  //   return header + calendarBody + paddingTop - paddingBottom;
  // }

  // calendarBodyHeight = 0;

  trackDate = (index, date: DateModel) => date.date;
  trackKey = (index, house) => house.unique_key;

  trackRenderId = (index, item: Bar & Parent & PriceChild) => {
    if (item.r_type === "bar") {
      return item.b_title;
    } else if (item.r_type === "group") {
      return item.p_id;
    } else {
      return item.c_id;
    }
  };

  @Translate("component.multi_house_price_calendar.historical_price_cannot_be_changed") historyWarning;

  get isInternational() {
    return this.app.app.international;
  }

  constructor(
    private app: AppService,
    private calendarService: CalendarBuilder,
    private indexService: IndexService,
    private houseCalendarService: MultiHouseCalendarService,
    private messageService: NzMessageService,
    private globalModal: ModalService,
    private international: InternationalService,
    private dateService: DateService,
    private cacheSrv: CacheService,
    public router: Router,
  ) {}

  ngOnInit() {
    // this.cursor$.pipe(takeUntil(this.destroy$)).subscribe(value => {});
    this.dateFormatChange$.pipe(takeUntil(this.destroy$)).subscribe();
    this.resize$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      console.log("resize$");
      this._changeDate();
    });
    this.select$.pipe(takeUntil(this.destroy$)).subscribe((result) => {});

    // this.selectReservation$.pipe(takeUntil(this.destroy$)).subscribe();

    this.scroll$.pipe(takeUntil(this.destroy$)).subscribe();

    this.listOfAllDates = this.calendarService.buildDefaultCalendar();

    console.log("list of all dates: ", this.listOfAllDates);
  }

  ngAfterViewInit() {
    /**
     * TODO: 解决scroll延迟触发的问题
     * question: 在刷新页面的时候，如果页面不可见，scroll事件不会触发，只* 有当页面重新可见的时候才会开始触发
     */
    let scrollTimer;
    console.log("native element: ", this.calendarContainer);
    fromEvent(this.calendarContainer.nativeElement, "scroll")
      .pipe(
        tap((event: Event) => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            /** 在某些浏览器下，scrollLeft为小数，导致计算不准确，这里强行转为整数 */
            const scrollLeft = Math.ceil((event.target as HTMLElement).scrollLeft);
            const cursor = Math.floor(scrollLeft / this.cellWidth);

            if (cursor !== this.cursor) {
              // 左右滚动
              this.cursor = cursor;
              this._changeDate();
            } else {
              // 上下滚动
              const target = event.target as HTMLElement;
              this.checkIfScrollToBottom(target);
            }

            /**
             * 4.0.3暂时添加
             * @TODO 优化逻辑
             */
            this.tmpCalculateIsFirstDayInView(scrollLeft);

            const keys = this.collectUniqueKeysInViewport(event.target);
            this.onScrollOfKeys.emit(keys);
            // this.cursor = cursor;
            //
            // this._changeDate();
          }, 100);
        }),
        // debounceTime(300),
        takeUntil(this.destroy$),
      )
      .subscribe((event: Event) => {
        // this._changeDate();
      });

    /** fix: ExpressionChangedAfterItHasBeenCheckedError */
    setTimeout(() => {
      this.recalculateDatesInViewCount();
      this.scroll(363);
    });

    // const host = this.elementRef.nativeElement;

    // const rect = host.getBoundingClientRect();
    // this.hostStyle = {
    //   height: `calc(100vh - ${rect.top}px)`,
    // };
    // this.bodyStyle = {
    //   height: `calc(100vh - ${rect.top - 80}px)`,
    // };

    // setTimeout(() => {
    //   this.tmpPropertyWithoutPriceScrollIntoView(104294);
    // }, 5000);
  }

  private tmpCalculateIsFirstDayInView(scrollLeft: number) {
    this.listOfDatesInView.forEach((item) => (item["isFirstDayInView"] = false));
    if (this.listOfDatesInView[0]?.offsetStart * this.cellWidth < scrollLeft) {
      this.listOfDatesInView[0]["isFirstDayInView"] = false;
      this.listOfDatesInView[1]["isFirstDayInView"] = true;
    } else {
      this.listOfDatesInView[0]["isFirstDayInView"] = true;
    }
  }

  private collectUniqueKeysInViewport(container) {
    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.clientHeight;
    const listItems = this.houseBody?.nativeElement.querySelectorAll(".house-item");

    const keys = [];
    // 遍历列表项，找出在视图范围内的元素
    for (let i = 0; i < listItems?.length; i++) {
      const listItem = listItems[i];
      const listItemTop = listItem.offsetTop;
      const listItemBottom = listItemTop + listItem.offsetHeight;

      /**
       *  判断列表项是否在视图范围内
       *  这里加 46 是为了让列表项在视图范围内时，上部有一定的缓冲区，46 正好是一行的高度
       */
      if (listItemTop + 46 >= containerTop && listItemBottom <= containerBottom) {
        // 当前列表项在视图范围内
        // listItem.classList.add("active");
        keys.push(listItem.getAttribute("data-key"));
      } else {
        // 当前列表项不在视图范围内
        // listItem.classList.remove("active");
      }
    }
    this.houseIdsInViewport = new Set(keys);
    return keys;
  }

  // private tmpPropertyWithoutPriceScrollIntoView(uniqueKey) {
  //   const selector = `[data-key="${uniqueKey}"]`;
  //   const calendar = this.calendarBody.nativeElement as HTMLElement;
  //   const row = calendar.querySelector(selector);
  //   console.log("row: ", row);
  //   row.scrollIntoView({ behavior: "smooth" });
  // }

  /**
   * @deprecated
   */
  getCalendarBodyHeight() {
    if (_.isEmpty(this.listOfHouses)) {
      return 0;
    }
    const header = 80;
    const calendarBody = this.calendarBody.nativeElement.clientHeight;
    const paddingBottom = 60;
    const paddingTop = 10;

    return header + calendarBody + paddingTop - paddingBottom;
  }

  onClickHouse(child: Child, parent: Parent, tab = 1) {
    if (parent.p_type === 1) {
      // 房型
      this.globalModal.displayRoomTypeDetailDrawer(parent.p_id, tab, {
        origin_house_id: child["origin_house_id"],
      });
    } else {
      // 独立房间
      this.globalModal.displayPropertyDetailDrawer(parent.p_id, tab, {
        origin_house_id: child["origin_house_id"],
      });
    }
  }

  onClickCell(house: PriceChild, date) {
    // if (house.c_readonly) {
    //   return;
    // }

    const dateStr = date.date;
    const calendar = _.get(this.calendarMap, [house.c_id, dateStr]);
    if (date.value.isBefore(moment().subtract(1, "d"), "d")) {
      this.messageService.warning(this.historyWarning);

      return;
    }
    // if (calendar && calendar.reservation) {
    //   return;
    // }
    if (this.selectStatus === "none" || this.selectStatus === "done") {
      this.selectStatus = "doing";

      this.select(
        {
          head: date.value,
          last: date.value,
        },
        { type: "house", payload: house },
      );
    } else {
      this.selectStatus = "done";

      const date = this.selectedCellDates;
      const data = this.listOfSelectedData;

      /** 结束托选后，需要排一下序，防止反向托选时head大于last */
      const [head, last] = [moment.min(date.head, date.last), moment.max(date.head, date.last)];
      // const id = data.id;
      const id = (data.payload as PriceChild)?.c_id;

      // const relatedHouse = house.c_parent.p_children.find((house) => house.c_id === id);
      // const houses = this.listOfHouses[house.type];
      // const relatedHouse = _.find(houses, (house) => {
      //   const keys = house.unique_keys;
      //   return _.find(keys, (key) => key === id);
      // });
      // const relatedHouse = _.find(this.listOfHouses, house => {
      //   const keys = house.unique_keys;
      //   return _.find(keys, key => key === id);
      // });
      /** TODO: DELETE */
      // _.assign(relatedHouse, {
      //   currentThirdparty: house.thirdparty_type,
      //   currentId: id
      // });

      const houseCalendar = this.calendarMap[id] || {};
      const sliced = _.filter(
        houseCalendar,
        (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"),
      );
      console.log("related house: ", house);
      this.updateDataOfShortcutPop(sliced, house);

      this.select(
        { head, last },
        {
          // id,
          // related: relatedHouse,
          // 以上字段废弃
          type: "house",
          payload: house,
        },
      );
      this.scrollIntoView();
    }
  }

  onHoverCell(house: any, date: DateModel) {
    if (this.selectStatus !== "doing") {
      return;
    }

    const { head, last } = this.selectedCellDates;
    const { c_id } = this.listOfSelectedData.payload as PriceChild;
    const currentLast = date.value;

    /** 1，其他房源不允许选择 */
    if (house.unique_key !== c_id) {
      return;
    }

    /** 2，过去日期不允许选择 */
    if (date.value.isBefore(moment(), "d")) {
      return;
    }

    /**
     * @deprecated
     * 3，范围内有订单不允许选择
     *
     * v4.7.0去除该限制
     *  */
    // let hasReservation = false;
    // _.forOwn(this.calendarMap[house.unique_key], (value) => {
    //   if (value.reservation) {
    //     if (this.isBetween(moment(value.date), head, currentLast)) {
    //       hasReservation = true;
    //       return false;
    //     }
    //   }
    // });

    this.select(
      {
        ...this.selectedCellDates,
        last: currentLast,
      },
      this.listOfSelectedData,
    );

    if (this.detectAtCalendarEdge(date)) {
      this.scrollIntoView();
    }

    // this.calendarEdgeDetection(date);
  }

  // test
  isBetween(date: Moment, head, last) {
    // const { head, last } = this.listOfSelectedDates;

    if (!head && !last) {
      return;
    }

    const [_head, _last] = [moment.min(head, last), moment.max(head, last)];

    return date.isSameOrAfter(_head, "d") && date.isSameOrBefore(_last, "d");
  }

  isHead(date: Moment) {
    const { head, last } = this.selectedCellDates;
    if (!head && !last) {
      return;
    }
    return date.isSame(moment.min(head, last), "d");
  }

  isLast(date: Moment) {
    const { head, last } = this.selectedCellDates;
    if (!head && !last) {
      return;
    }
    return date.isSame(moment.max(head, last), "d");
  }

  getFreeHouseCount(date) {
    const count = _.get(this.freeHouseCountMap, [date, "can_sell"]);
    const result = count || count === 0 ? count : "-";
    if (this.isInternational) {
      return result;
    }
    return "余" + result;
  }

  getPrice(house, date): string {
    const { unique_key, thirdparty_type } = house;
    let price = _.get(this.calendarMap, [unique_key, date, "price"]) || 0;

    if (thirdparty_type === PlatformType.Ctrip && price === -1) {
      return "";
    }

    return this.displayThousandsSep ? addThousandsSeparator(price) : `${price}`;
  }

  getInventory(house, date) {
    const { unique_key } = house;
    return _.get(this.calendarMap, [unique_key, date, "inventory"]) || 0;
  }

  updateDataOfShortcutPop(calendars = [], entity: Child) {
    let status: "open" | "close" | "diff" | "past" = "open";
    let list = null;

    const head = _.head(calendars);
    // const type = entity && entity.type;
    const type = entity?.c_parent?.p_type;
    if (head.type === "past") {
      this.dataOfShortcutPop = { status: "past", list };
      return;
    }

    if (calendars.length === 1) {
      /**
       * 单天分为 打开  关闭  不一致三种状态
       * 其中不一致状态需要显示具体不一致的渠道信息
       */
      const calendar = _.head(calendars) || {};
      if (calendar.available === 0) {
        status = "close";
      } else if (calendar.available === 1) {
        status = "open";
      } else {
        status = "diff";

        list = _.groupBy(calendar.housing_status, "available");
      }
    } else {
      /**
       * 多天分为 打开  关闭  不一致三种状态
       * 不一致状态不需要显示具体渠道信息
       */
      if (_.every(calendars, (calendar) => calendar.available === 0)) {
        status = "close";
      } else if (_.every(calendars, (calendar) => calendar.available === 1)) {
        status = "open";
      } else {
        status = "diff";
      }
    }

    this.dataOfShortcutPop = { status, list, type };
    console.log("dataOfSelectedDates: ", this.dataOfShortcutPop);
  }

  detectAtCalendarEdge(date: DateModel): boolean {
    const lastDates = _.takeRight(this.listOfDatesInView, 2);
    return !!_.find(lastDates, (d) => d.date === date.date);
  }

  setSelectedRectStyle() {
    const head = this.selectedCellDates.head;
    const last = this.selectedCellDates.last;

    const headIdx = this.calendarService.offsetStart(head);
    const lastIdx = this.calendarService.offsetStart(last);

    const left = Math.min(headIdx, lastIdx) * this.cellWidth;
    const width = (Math.abs(lastIdx - headIdx) + 1) * this.cellWidth;
    this.selectedRectStyle = { left, width };
  }

  scrollIntoView() {
    const padding = 2; // 额外滚动的天数
    const sidebarWidth = 392;

    const sidebarLengthOfDays = Math.ceil(sidebarWidth / this.cellWidth); // 侧边栏占用的天数
    const selectedLast = this.selectedCellDates.last;
    const rangeLast = _.last(this.listOfDatesInView).date;

    const offsetLengthOfDays = moment(rangeLast).diff(selectedLast, "d"); // 选择的最后一天与屏幕的最后一天的差距，单位：天

    if (offsetLengthOfDays <= sidebarLengthOfDays) {
      this.scroll(this.cursor + (sidebarLengthOfDays - offsetLengthOfDays) + padding);
    }
  }

  /**
   * 滚动到指定日期
   * @params cursor 日期的索引
   */
  scroll(cursor: number) {
    this.calendarContainer.nativeElement.scrollLeft = cursor * this.cellWidth;
  }

  /**
   * 滚动到指定位置
   * @params position 要滚动的位置
   */
  scrollToPosition(position: number) {
    this.calendarContainer.nativeElement.scrollLeft = position;
  }

  /**
   * 滚动指定距离
   * @params position 要滚动的距离
   */
  scrollByDistance(distance: number) {
    const currentLeft = this.calendarContainer.nativeElement.scrollLeft;
    this.calendarContainer.nativeElement.scrollLeft = currentLeft - distance;
  }

  checkIfScrollToBottom(target: HTMLElement) {
    if (target.clientHeight + target.scrollTop + 14 >= target.scrollHeight) {
      this.onCalendarScrollToBottom.emit(true);
      // this.displayPagination();
    } else {
      this.onCalendarScrollToBottom.emit(false);
      // this.dismissPagination();
    }
  }

  recalculateDatesInViewCount() {
    /**
     * calendarContainer的宽度是固定的，datesInViewCount也是固定的
     * 因此在某种情况下（即滑动日历，第一个cell的右边界没有完全到达calendarContainer的左边界时）
     * 此时拉伸浏览器窗口时，如果拉伸的宽度小于cellWidth，会导致最右端的cell无法渲染出来而出现一格的空白。故在此加1以修正这种情况。
     */
    this.datesInViewCount = Math.ceil(this.calendarContainer.nativeElement.offsetWidth / this.cellWidth) + 1;
  }

  // _cursor(cursor: number) {
  //   this.cursorRaw$.next(cursor);
  // }

  changeHouseAvailable(status: 0 | 1) {
    // const { relatedHouse } = this.listOfSelectedDates;
    this.onClickChangeAvailable.emit({
      status,
      // thirdparty: this.listOfSelectedData.thirdparty,
      thirdparty: (this.listOfSelectedData.payload as PriceChild)?.thirdparty_type,
    });
    this.houseCalendarService.cancelSelect();
  }

  hideShortcutPop() {
    this.displayShortcutPop = false;
  }

  // toPropertyDetailPage(params) {
  //   this.router.navigate(['/app/properties']);
  //   setTimeout(() => {
  //     this.router.navigate(['/app/properties/detail'], params);
  //   }, 200);
  // }

  // toPropertyTypeDetailPage(params) {
  //   this.router.navigate(['/app/properties']);
  //   setTimeout(() => {
  //     console.log('params: ', params);
  //     this.router.navigate(['/app/room_types/detail'], params);
  //   }, 200);
  // }

  _changeTab(name) {
    this.onClickChangeTab.emit(name);
    this.hideShortcutPop();
  }

  _changeDate() {
    const beginCursor = this.cursor;
    const endCursor =
      this.cursor + this.datesInViewCount >= this.listOfAllDates.length
        ? this.listOfAllDates.length - 1
        : this.cursor + this.datesInViewCount;
    this.houseCalendarService.dateChangeRaw$.next([
      _.get(this.listOfAllDates[beginCursor], "date"),
      _.get(this.listOfAllDates[endCursor], "date"),
    ]);
  }

  select(value, data = null) {
    this.houseCalendarService.select({
      status: this.selectStatus,
      dates: value,
      data: data,
    });
  }

  _selectReservation(code) {
    this.houseCalendarService.selectReservation(code);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
